import client from './client';
import type { LoginRequest, LoginResponse, User } from '@/types/auth';

export async function login(credentials: LoginRequest): Promise<LoginResponse> {
  const { data } = await client.post<LoginResponse>('/auth/login', {
    identifier: credentials.username,
    password: credentials.password,
  });
  return data;
}

export async function logout(): Promise<void> {
  try {
    await client.post('/auth/logout');
  } catch {
    // Ignore logout errors
  }
}

export async function getMe(): Promise<User> {
  const { data } = await client.get<User>('/auth/me');
  return data;
}
